import React from 'react';

function PDPGalleriesExtension() {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
            <esi:include src="/fragment/pdp-third-party-extensions-fe/pdp-galleries-content" />`,
      }}
    />
  );
}

export default PDPGalleriesExtension;
